import './DropdownIcon.scss'
import {ReactComponent as DropdownSvg} from 'assets/icons/dropdown.svg'
import {ReactComponent as DropdownSecondSvg} from 'assets/icons/dropdown-second.svg'

export default function DropdownIcon({second, ...props}: any) {
  const Component = second ? DropdownSecondSvg : DropdownSvg
  return <Component {...props} className="DropdownIcon" />
}
